// Smooth-scroll helper that uses the global Lenis instance when available.
export const scrollToId = (id) => {
  const selector = id.startsWith("#") ? id : `#${id}`;
  const el = document.querySelector(selector);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
